<template>
  <div>
    <el-select
      v-model='newValue'
      placeholder='请选择'
      clearable
      :multiple="multiple"
      @change='parentValue'
      style='width: 100%'
      :disabled='disabled'
    >
      <el-option
        v-for='item in options'
        :key='item.code'
        :label='item.name'
        :value='item.code'
      ></el-option>
    </el-select>
  </div>
</template>

<script>
  // import {CategoryMap} from '../js/CategoryMap.js';
  import { CategoryPetition } from '@/js/CategoryPetition';
  import { CategoryMapNeimeng } from '@/js/CategoryMapNeimeng.js';
  import { CategoryMapPaiZu } from '@/js/CategoryMapPaiZu.js';
  import { JxMapPaiZu } from '@/js/JxMapPaiZu.js';
  export default {
    name: 'Category',
    // props: ['categoryCode', 'value', 'parentId', 'disabled', 'tableData', 'partyPunishShow', 'othertreatShow'],
    props: {
      type: {
        type: String,
        default: 'clue'
      },
      // 父级code
      categoryCode: {
        type: String,
        required: true
      },
      value: {
        required: true
      },
      parentId: { // 查询子孙级的时候
        required: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      tableData: {
        type: Object,
        required: false
      },
      multiple: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    data() {
      return {
        options: [],
        newValue: ''
      };
    },
    mounted() {
      if(typeof this.value == 'string' && this.multiple){  //多选
        this.newValue = JSON.parse(this.value);
      }else{
        this.newValue = this.value;
      }
      this.options = [];
      for (let i = 0; i < this.optitonCode.length; i++) {
        if (this.categoryCode === this.optitonCode[i].code) {
          this.options = this.optitonCode[i].children;
        }
      }
      if (this.parentId.length > 0) {
        for (let i = 0; i < this.optitonCode.length; i++) {
          if (this.categoryCode === this.optitonCode[i].code) {
            this.options = this.child(this.optitonCode[i].children, 0);
          }
        }
      }
    },
    computed: {
      optitonCode() {
        if (this.type === 'clue') {
          return CategoryMapNeimeng
        } else if (this.type === 'petition') {
          return CategoryPetition
        } else if (this.type === 'xs') {
          return CategoryMapPaiZu
        } else if (this.type === 'questionType') {
          return JxMapPaiZu
        }
      }
    },
    watch: {
      parentId(val, oldVal) {
        if (this.parentId.length > 0) {
          for (let i = 0; i < this.optitonCode.length; i++) {
            if (this.categoryCode === this.optitonCode[i].code) {
              this.options = this.child(this.optitonCode[i].children, 0);
            }
          }
        }
      },
      value(val, oldVal) {
        this.newValue = val;
        for (let i = 0; i < this.optitonCode.length; i++) {
          if (this.categoryCode === this.optitonCode[i].code) {
            this.options = this.optitonCode[i].children;
          }
        }
        if (this.parentId.length > 0) {
          for (let i = 0; i < this.optitonCode.length; i++) {
            if (this.categoryCode === this.optitonCode[i].code) {
              this.options = this.child(this.optitonCode[i].children, 0);
            }
          }
        }
      }
    },
    methods: {
      parentValue() {
        if (this.tableData) {
          let temp = true;
          if (this.tableData[0].thirdBreak) {
            for (let i = 0; i < this.tableData.length; i++) {
              if (this.tableData[i].thirdBreak === this.newValue) {
                temp = false
              }
            }
          } else if (this.tableData[0].secondBreak) {
            for (let i = 0; i < this.tableData.length; i++) {
              if (this.tableData[i].secondBreak === this.newValue) {
                temp = false
              }
            }
          }
          if (temp) {
            this.$emit('update:value', this.newValue);
          } else {
            this.newValue = '';
            this.$emit('update:value', 'repetition');
          }
        } else this.$emit('update:value', this.newValue);
      },
      child(children, num) {
        if (num < this.parentId.length) {
          for (let j = 0; j < children.length; j++) {
            // console.log(children[j].code +'&&&&&'+this.parentId[num]);
            if (children[j].code === this.parentId[num]) {
              return this.child(children[j].children, num + 1);
            }
          }
        } else {
          return children;
        }
      },
      repetition() {

      }
    }
  };
</script>


// WEBPACK FOOTER //
// src/components/MySelect.vue